import api from "../api/api";

const state = () => ({
  reviews: null,
  stats: null,
  filterCategories: null,
  activeFilter: -1,
});

const mutations = {
  setReviews(state, data) {
    state.reviews = data;
  },
  setStats(state, data) {
    state.stats = data;
  },
  setFilterCategories(state, data) {
    state.filterCategories = data;
  },
  setActiveFilter(state, data) {
    state.activeFilter = data;
  },
};

const getters = {
  getReviews(state) {
    return state.reviews;
  },
  getStats(state) {
    return state.stats;
  },
  getActiveFilter(state) {
    return state.activeFilter;
  },
  getFilterCategories(state) {
    if (!state.filterCategories || !state.filterCategories.success) {
      return [];
    }

    //service_type: 1,2,3
    const filters = [
      {
        text: "Dota2. Буст",
        serviceType: 3,
      },
    ];

    //service_type: 4
    const categoriesFilters = state.filterCategories.data.items.map(
      (category) => {
        return {
          text: `${category.game.name_short}. ${category.name}`,
          serviceType: 4,
          gameId: category.game_id,
          categoryId: category.id,
        };
      }
    );

    const result = [
      ...filters,
      //...categoriesFilters,
    ];

    result.forEach(
      (filter, filterIndex) =>
        (filter["isActive"] = filterIndex == state.activeFilter)
    );

    return result;
  },
};

const actions = {
  async GET_REVIEWS({ commit }, data) {
    try {
      const reviewsResponse = await api.reviews.find(data.queryParams);

      commit("setReviews", reviewsResponse.data);

      return reviewsResponse.data;
    } catch (err) {
      commit("setReviews", err.response);

      return err.response;
    }
  },
  async GET_STATS({ commit }, data) {
    try {
      const statsResponse = await api.reviews.getStats();

      commit("setStats", statsResponse.data);

      return statsResponse.data;
    } catch (err) {
      commit("setStats", err.response);

      return err.response;
    }
  },
  async GET_FILTER_CATEGORIES({ commit }, data) {
    try {
      const categoriesResponse = await api.categories.find({
        fields: "id,name,game_id",
        expand: "game",
      });

      commit("setFilterCategories", categoriesResponse.data);

      return categoriesResponse.data;
    } catch (err) {
      commit("setFilterCategories", err.response);

      return err.response;
    }
  },
};

const reviews = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};

export default reviews;
